// import {
//     Button,
//     Pagination,
//     Popconfirm,
//     Spin,
//     Table,
//     Tag,
//     Input,
//     message,
//     Switch,
//     Select,
//     Flex,
//     Popover,
//     Card,
// } from "antd";
// import React, { useEffect, useRef, useState } from "react";
// import { ExtractDate, ExtractTime, messageConfiguration } from "../../../utils";
// import { getordersDetails, getallrestroList, restroDisabled } from "../../../ApiServices/Apifun";
// import {
//     DeleteOutlined,
//     LoadingOutlined,
//     PlusCircleOutlined,
//     PlusOutlined,
// } from "@ant-design/icons";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import ComponentTitle from "../../../Common/ComponentTitle";
// import { render } from "@testing-library/react";
// import errorImage from "../../../assets/images/food.png"


// const AllRestroList = () => {

//     const [orderData, setorderData] = useState([]);
//     const [openModal, setOpenModal] = useState(false);
//     const [currentStatus, setCurrentStatus] = useState();

//     const handleChangeStatus = (id, status) => {
//         setIsLoading(true);
//         console.log(status);
//         const newStatus = status == 1 ? "0" : "1"; // Toggle status

//         restroDisabled({

//             "isActive": newStatus,
//             "restaurantId": id

//         })
//             .then((response) => {
//                 if (response.status) {
//                     message.success("Status updated successfully");
//                     setCurrentStatus(newStatus); // Update local state
//                     FetchordersDetails();
//                 } else {
//                     message.error("Failed to update status");
//                 }
//                 setIsLoading(false);
//             })
//             .catch((err) => {
//                 console.error("Error updating status:", err);
//                 message.error("An error occurred while updating the status");
//                 setIsLoading(false);
//             });
//     };

//     const popoverContent = (id, status) => (
//         <div>
//             <p>Are you sure you want to change the status?</p>
//             <Button
//                 type="primary"
//                 onClick={() => handleChangeStatus(id, status)}
//                 disabled={isLoading}
//             >
//                 {isLoading ? <Spin size="small" /> : "Confirm"}
//             </Button>
//         </div>
//     );

//     const [isLoading, setIsLoading] = useState(false);
//     const [pageSize, setPageSize] = useState(10);
//     const [totalPages, setTotalPages] = useState();
//     const [currentPage, setCurrentPage] = useState(1);
//     const [action, setAction] = useState("");
//     const [searchTerm, setSearchTerm] = useState("");
//     const lastQuery = useRef("");
//     const { Search } = Input;
//     const navigate = useNavigate();
//     const location = useLocation();
//     const { id } = useParams();
//     const from = location.state?.from;


//     const FetchordersDetails = (page = 1) => {
//         setIsLoading(true);
//         getallrestroList(`?search=${searchTerm}&page=${page}&limit=10`)
//             .then((response) => {
//                 if (response.status) {
//                     setorderData(response.data || []);
//                     setCurrentPage(response.pagination.currentPage || 1);
//                     setTotalPages(response.pagination.totalPages || 0);
//                 }
//                 setIsLoading(false);
//             })
//             .catch((err) => {
//                 console.error("Error fetching order details:", err);
//                 setIsLoading(false);
//             });
//     };
//     const handlePageChange = (page) => {
//         setCurrentPage(page); // Update state to trigger useEffect
//     };

//     const handleErrorImage = (e) => {

//         e.target.src = errorImage

//     }
//     const setwithdrawAction = (id, value) => {
//         setAction((prevAction) => ({
//             ...prevAction,
//             [id]: value,
//         }));
//     };

//     useEffect(() => {
//         const query = `?search=${searchTerm}&page=${currentPage}&limit=10`;
//         if (query === lastQuery.current) {
//             return;
//         }
//         lastQuery.current = query;
//         FetchordersDetails(currentPage);
//     }, [currentPage, searchTerm]);


//     const columnReports = [
//         {
//             title: "User Name",
//             dataIndex: "username",
//             key: "username",
//             className: "custom-header",
//             render: (data, record) => {
//                 return (
//                     <>
//                         <p className="text-xs font-poppins">
//                             {record.username?.toUpperCase() ?? "--"}
//                         </p>
//                     </>
//                 );
//             },
//         },
//         {
//             title: "Email",
//             dataIndex: "email",
//             key: "email",
//             className: "custom-header",
//             render: (data, record) => {
//                 return (
//                     <>
//                         <p className="text-xs font-poppins">{record.email ?? "--"}</p>
//                     </>
//                 );
//             },
//         },
//         {
//             title: "Contact",
//             dataIndex: "phone",
//             key: "phone",
//             className: "custom-header",
//             render: (data, record) => {
//                 return (
//                     <>
//                         <p className="text-xs font-poppins">{record.phone ?? "--"}</p>
//                     </>
//                 );
//             },
//         },

//         {
//             title: "Created Time",
//             dataIndex: "register_date",
//             key: "register_date",
//             className: "custom-header",
//             render: (data, record) => {
//                 return (
//                     <>
//                         <p className="text-xs font-poppins">
//                             {ExtractDate(record.createdAt)}.{ExtractTime(record.createdAt)}
//                         </p>
//                     </>
//                 );
//             },
//         },
//         {
//             title: "Action",
//             dataIndex: "status",
//             key: "status",
//             className: "custom-header",
//             render: (data, record) => {
//                 return (
//                     <div>
//                         <Select
//                             disabled={record.isRejected === "1" || record.isApproved === "1"}
//                             placeholder={
//                                 record.isRejected === "1"
//                                     ? "Rejected"
//                                     : record.isApproved === "1"
//                                         ? "Approved"
//                                         : "Select "
//                             }
//                             style={{
//                                 width: 120,
//                             }}
//                             onChange={(value) => setwithdrawAction(record.id, value)}
//                             value={action[record.id]}
//                         >
//                             <Select.Option value="approve">Approved</Select.Option>
//                             <Select.Option value="reject">Rejected</Select.Option>
//                         </Select>
//                         {action[record.id] === "reject" && (
//                             <Popconfirm
//                                 title={
//                                     <div>
//                                         <p style={{ marginBottom: "8px", fontWeight: "bold" }}>
//                                             Are you sure to reject this request?
//                                         </p>
//                                     </div>
//                                 }
//                                 // onConfirm={() => changeRequestStatus("reject", record)}
//                                 okText="Yes"
//                                 cancelText="Cancel"
//                             >
//                                 <Button type="link">Submit</Button>
//                             </Popconfirm>
//                         )}
//                         {action[record.id] === "approve" && (
//                             <Popconfirm
//                                 title={
//                                     <div>
//                                         <p style={{ marginBottom: "8px", fontWeight: "bold" }}>
//                                             Are you sure to approve this request?
//                                         </p>
//                                     </div>
//                                 }
//                                 // onConfirm={() => changeRequestStatus("approve", record)}
//                                 okText="Yes"
//                                 cancelText="Cancel"
//                             >
//                                 <Button type="link" size="small">
//                                     Submit
//                                 </Button>
//                             </Popconfirm>
//                         )}
//                     </div>
//                 );
//             },
//         },
//     ];
//     const dataSource = [
//         {
//             key: "1",
//             name: "Mike",
//             age: 32,
//             address: "10 Downing Street",
//             date: "15 December, 2020",
//         },
//         {
//             key: "2",
//             name: "John",
//             age: 42,
//             address: "10 Downing Street",
//             date: "15 December, 2020",
//         },
//         {
//             key: "3",
//             name: "John",
//             age: 42,
//             address: "10 Downing Street",
//             date: "15 December, 2020",
//         },
//         {
//             key: "4",
//             name: "John",
//             age: 42,
//             address: "10 Downing Street",
//             date: "15 December, 2020",
//         },
//         {
//             key: "5",
//             name: "John",
//             age: 42,
//             address: "10 Downing Street",
//             date: "15 December, 2020",
//         },
//     ];

// const columns = [
//     {
//         title: "Name",
//         dataIndex: "name",
//         key: "name",
//         className: "custom-header",
//         render: (text) => {
//             return (
//                 <p className="font-medium">
//                     {text ? text : "-"}
//                 </p>
//             );
//         },
//     },
//     {
//         title: "Email",
//         dataIndex: "email",
//         key: "email",
//         className: "custom-header whitespace-nowrap",
//         render: (text) => {
//             return (
//                 <p className="font-medium w-[120px]">
//                     {text ? text : "-"}
//                 </p>
//             );
//         },
//     },
//     {
//         title: "Phone no.",
//         dataIndex: "mobile_number",
//         key: "mobile_number",
//         className: "custom-header",
//         render: (text) => {
//             return (
//                 <p className="font-medium w-[120px]">
//                     {text ? text : "-"}
//                 </p>
//             );
//         },
//     },
//     {
//         title: "Created Time",
//         dataIndex: "register_date",
//         key: "register_date",
//         className: "custom-header",
//         render: (data, record) => {
//             return (
//                 <p className="text-xs">
//                     {ExtractDate(record.createdAt)}.
//                     {ExtractTime(record.createdAt)}
//                 </p>
//             );
//         },
//     },
//     {
//         title: "Status",
//         dataIndex: "is_active",
//         key: "is_active",
//         className: "custom-header",
//         render: (_, record) => (
//             <Popover
//                 content={popoverContent(record.id, record.is_active)}
//                 trigger="click"
//                 placement="bottom"
//             >
//                 <Tag
//                     style={{
//                         fontWeight: "bold",
//                         color: record.is_active == 1 ? "green" : "red",
//                         backgroundColor:
//                             record.is_active == 1
//                                 ? "#e0f5f0"
//                                 : "#FFE1E1",
//                         borderColor:
//                             record.is_active == 1
//                                 ? "lightgreen"
//                                 : "pink",
//                         borderRadius: "0px",
//                         cursor: "pointer",
//                     }}
//                 >
//                     {record.is_active == 1
//                         ? "Active"
//                         : "Inactive"}
//                 </Tag>
//             </Popover>
//         ),
//     },
// ];

//     return (
//         <div className="p-0 md:p-4">
//             <div className="flex flex-col sm:flex-row justify-end mb-4 gap-2">
//                 <Input
//                     placeholder="Search user by name..."
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                     className="w-full sm:w-1/4"
//                 />
//             </div>
            
//             {/* Card Wrapper for Table */}
//             <Card
//                 title="Restaurant Data"
//                 className="shadow-sm shadow-gray-300"
//             >
//                 <Table
//                     bordered={true}
//                     loading={isLoading}
//                     columns={columns}
//                     dataSource={orderData}
//                     pagination={false}
//                     className="history-table animate-fade-in max-h-[500px] overflow-x-auto text-white rounded-lg"
//                     size="small"
//                 />
//             </Card>

//             {/* Pagination */}
//             <div className="flex flex-col sm:flex-row justify-between items-center gap-2 mt-4">
//                 <div className="text-sm text-gray-600">
//                     {`Showing ${currentPage * 10 - 9} to ${currentPage * 10 > totalPages * 10 ? totalPages * 10 : currentPage * 10
//                         } of ${totalPages * 10} items`}
//                 </div>
//                 <Pagination
//                     total={totalPages * 10}
//                     onChange={handlePageChange}
//                     defaultPageSize={10}
//                     current={currentPage}
//                     size="small"
//                 />
//             </div>
//         </div>
//     );
// };
// export default AllRestroList;


import {
    Button,
    Pagination,
    Popconfirm,
    Spin,
    Table,
    Tag,
    Input,
    message,
    Switch,
    Select,
    Flex,
    Popover,
    Card,
    Modal,
    Form,
    InputNumber,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { ExtractDate, ExtractTime, messageConfiguration } from "../../../utils";
import {
    getordersDetails,
    getallrestroList,
    restroDisabled,
    createRestaurant,
    updateRestaurant,
} from "../../../ApiServices/Apifun";
import {
    DeleteOutlined,
    EditOutlined,
    LoadingOutlined,
    PlusCircleOutlined,
    PlusOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ComponentTitle from "../../../Common/ComponentTitle";
import { render } from "@testing-library/react";
import errorImage from "../../../assets/images/food.png"


const AllRestroList = () => {

    const [orderData, setorderData] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [currentStatus, setCurrentStatus] = useState();

    // ── Create / Edit modal state ──
    const [isFormModalOpen, setIsFormModalOpen] = useState(false);
    const [modalMode, setModalMode] = useState("add"); // "add" | "edit"
    const [editingRecord, setEditingRecord] = useState(null);
    const [formLoading, setFormLoading] = useState(false);
    const [form] = Form.useForm();

    const handleChangeStatus = (id, status) => {
        setIsLoading(true);
        console.log(status);
        const newStatus = status == 1 ? "0" : "1"; // Toggle status

        restroDisabled({

            "isActive": newStatus,
            "restaurantId": id

        })
            .then((response) => {
                if (response.status) {
                    message.success("Status updated successfully");
                    setCurrentStatus(newStatus); // Update local state
                    FetchordersDetails();
                } else {
                    message.error("Failed to update status");
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.error("Error updating status:", err);
                message.error("An error occurred while updating the status");
                setIsLoading(false);
            });
    };

    const popoverContent = (id, status) => (
        <div>
            <p>Are you sure you want to change the status?</p>
            <Button
                type="primary"
                onClick={() => handleChangeStatus(id, status)}
                disabled={isLoading}
            >
                {isLoading ? <Spin size="small" /> : "Confirm"}
            </Button>
        </div>
    );

    const [isLoading, setIsLoading] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [action, setAction] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const lastQuery = useRef("");
    const { Search } = Input;
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const from = location.state?.from;


    const FetchordersDetails = (page = 1) => {
        setIsLoading(true);
        getallrestroList(`?search=${searchTerm}&page=${page}&limit=10`)
            .then((response) => {
                if (response.status) {
                    setorderData(response.data || []);
                    setCurrentPage(response.pagination.currentPage || 1);
                    setTotalPages(response.pagination.totalPages || 0);
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching order details:", err);
                setIsLoading(false);
            });
    };
    const handlePageChange = (page) => {
        setCurrentPage(page); // Update state to trigger useEffect
    };

    const handleErrorImage = (e) => {

        e.target.src = errorImage

    }
    const setwithdrawAction = (id, value) => {
        setAction((prevAction) => ({
            ...prevAction,
            [id]: value,
        }));
    };

    useEffect(() => {
        const query = `?search=${searchTerm}&page=${currentPage}&limit=10`;
        if (query === lastQuery.current) {
            return;
        }
        lastQuery.current = query;
        FetchordersDetails(currentPage);
    }, [currentPage, searchTerm]);

    // ── Open modal for "Add Restaurant" ──
    const handleOpenAddModal = () => {
        setModalMode("add");
        setEditingRecord(null);
        form.resetFields();
        setIsFormModalOpen(true);
    };

    // ── Open modal for "Edit Restaurant" ──
    const handleOpenEditModal = (record) => {
        setModalMode("edit");
        setEditingRecord(record);
        form.setFieldsValue({
            name: record.name,
            email: record.email,
            mobile_number: record.mobile_number,
            address: record.address,
        });
        setIsFormModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsFormModalOpen(false);
        setEditingRecord(null);
        form.resetFields();
    };

    // ── Submit handler for both Add & Edit ──
    const handleFormSubmit = (values) => {
        setFormLoading(true);

        if (modalMode === "add") {
            const payload = {
                name: values.name,
                email: values.email,
                mobile_number: values.mobile_number,
                password: values.password,
                address: values.address,
            };
            createRestaurant(payload)
                .then((response) => {
                    if (response.status === "success") {
                        message.success(response.message || "Restaurant created successfully");
                        handleCloseModal();
                        FetchordersDetails(currentPage);
                    } else {
                        message.error(response.message || "Failed to create restaurant");
                    }
                })
                .catch((err) => {
                    console.error("Error creating restaurant:", err);
                    message.error(
                        err?.response?.data?.message || "Failed to create restaurant"
                    );
                })
                .finally(() => setFormLoading(false));
        } else {
            const payload = {
                name: values.name,
                email: values.email,
                mobile_number: values.mobile_number,
                address: values.address,
                is_active: editingRecord?.is_active ?? "1",
            };

            updateRestaurant(editingRecord.id, payload)
                .then((response) => {
                    if (response.status === "success") {
                        message.success(response.message || "Restaurant updated successfully");
                        handleCloseModal();
                        FetchordersDetails(currentPage);
                    } else {
                        message.error(response.message || "Failed to update restaurant");
                    }
                })
                .catch((err) => {
                    console.error("Error updating restaurant:", err);
                    message.error(
                        err?.response?.data?.message || "Failed to update restaurant"
                    );
                })
                .finally(() => setFormLoading(false));
        }
    };


    const columnReports = [
        {
            title: "User Name",
            dataIndex: "username",
            key: "username",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <>
                        <p className="text-xs font-poppins">
                            {record.username?.toUpperCase() ?? "--"}
                        </p>
                    </>
                );
            },
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <>
                        <p className="text-xs font-poppins">{record.email ?? "--"}</p>
                    </>
                );
            },
        },
        {
            title: "Contact",
            dataIndex: "phone",
            key: "phone",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <>
                        <p className="text-xs font-poppins">{record.phone ?? "--"}</p>
                    </>
                );
            },
        },

        {
            title: "Created Time",
            dataIndex: "register_date",
            key: "register_date",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <>
                        <p className="text-xs font-poppins">
                            {ExtractDate(record.createdAt)}.{ExtractTime(record.createdAt)}
                        </p>
                    </>
                );
            },
        },
        {
            title: "Action",
            dataIndex: "status",
            key: "status",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <div>
                        <Select
                            disabled={record.isRejected === "1" || record.isApproved === "1"}
                            placeholder={
                                record.isRejected === "1"
                                    ? "Rejected"
                                    : record.isApproved === "1"
                                        ? "Approved"
                                        : "Select "
                            }
                            style={{
                                width: 120,
                            }}
                            onChange={(value) => setwithdrawAction(record.id, value)}
                            value={action[record.id]}
                        >
                            <Select.Option value="approve">Approved</Select.Option>
                            <Select.Option value="reject">Rejected</Select.Option>
                        </Select>
                        {action[record.id] === "reject" && (
                            <Popconfirm
                                title={
                                    <div>
                                        <p style={{ marginBottom: "8px", fontWeight: "bold" }}>
                                            Are you sure to reject this request?
                                        </p>
                                    </div>
                                }
                                // onConfirm={() => changeRequestStatus("reject", record)}
                                okText="Yes"
                                cancelText="Cancel"
                            >
                                <Button type="link">Submit</Button>
                            </Popconfirm>
                        )}
                        {action[record.id] === "approve" && (
                            <Popconfirm
                                title={
                                    <div>
                                        <p style={{ marginBottom: "8px", fontWeight: "bold" }}>
                                            Are you sure to approve this request?
                                        </p>
                                    </div>
                                }
                                // onConfirm={() => changeRequestStatus("approve", record)}
                                okText="Yes"
                                cancelText="Cancel"
                            >
                                <Button type="link" size="small">
                                    Submit
                                </Button>
                            </Popconfirm>
                        )}
                    </div>
                );
            },
        },
    ];
    const dataSource = [
        {
            key: "1",
            name: "Mike",
            age: 32,
            address: "10 Downing Street",
            date: "15 December, 2020",
        },
        {
            key: "2",
            name: "John",
            age: 42,
            address: "10 Downing Street",
            date: "15 December, 2020",
        },
        {
            key: "3",
            name: "John",
            age: 42,
            address: "10 Downing Street",
            date: "15 December, 2020",
        },
        {
            key: "4",
            name: "John",
            age: 42,
            address: "10 Downing Street",
            date: "15 December, 2020",
        },
        {
            key: "5",
            name: "John",
            age: 42,
            address: "10 Downing Street",
            date: "15 December, 2020",
        },
    ];

const columns = [
    {
        title: "Name",
        dataIndex: "name",
        key: "name",
        className: "custom-header",
        render: (text) => {
            return (
                <p className="font-medium">
                    {text ? text : "-"}
                </p>
            );
        },
    },
    {
        title: "Email",
        dataIndex: "email",
        key: "email",
        className: "custom-header whitespace-nowrap",
        render: (text) => {
            return (
                <p className="font-medium w-[120px]">
                    {text ? text : "-"}
                </p>
            );
        },
    },
    {
        title: "Phone no.",
        dataIndex: "mobile_number",
        key: "mobile_number",
        className: "custom-header",
        render: (text) => {
            return (
                <p className="font-medium w-[120px]">
                    {text ? text : "-"}
                </p>
            );
        },
    },
    {
        title: "Created Time",
        dataIndex: "register_date",
        key: "register_date",
        className: "custom-header",
        render: (data, record) => {
            return (
                <p className="text-xs">
                    {ExtractDate(record.createdAt)}.
                    {ExtractTime(record.createdAt)}
                </p>
            );
        },
    },
    {
        title: "Status",
        dataIndex: "is_active",
        key: "is_active",
        className: "custom-header",
        render: (_, record) => (
            <Popover
                content={popoverContent(record.id, record.is_active)}
                trigger="click"
                placement="bottom"
            >
                <Tag
                    style={{
                        fontWeight: "bold",
                        color: record.is_active == 1 ? "green" : "red",
                        backgroundColor:
                            record.is_active == 1
                                ? "#e0f5f0"
                                : "#FFE1E1",
                        borderColor:
                            record.is_active == 1
                                ? "lightgreen"
                                : "pink",
                        borderRadius: "0px",
                        cursor: "pointer",
                    }}
                >
                    {record.is_active == 1
                        ? "Active"
                        : "Inactive"}
                </Tag>
            </Popover>
        ),
    },
    // ── New: Edit action column ──
    {
        title: "Action",
        key: "edit_action",
        className: "custom-header",
        render: (_, record) => (
            <Button
                type="link"
                icon={<EditOutlined />}
                onClick={() => handleOpenEditModal(record)}
            >
                Edit
            </Button>
        ),
    },
];

    return (
        <div className="p-0 md:p-4">
            <div className="flex flex-col sm:flex-row justify-between mb-4 gap-2">
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={handleOpenAddModal}
                >
                    Add Restaurant
                </Button>
                <Input
                    placeholder="Search user by name..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full sm:w-1/4"
                />
            </div>
            
            {/* Card Wrapper for Table */}
            <Card
                title="Restaurant Data"
                className="shadow-sm shadow-gray-300"
            >
                <Table
                    bordered={true}
                    loading={isLoading}
                    columns={columns}
                    dataSource={orderData}
                    pagination={false}
                    className="history-table animate-fade-in max-h-[500px] overflow-x-auto text-white rounded-lg"
                    size="small"
                />
            </Card>

            {/* Pagination */}
            <div className="flex flex-col sm:flex-row justify-between items-center gap-2 mt-4">
                <div className="text-sm text-gray-600">
                    {`Showing ${currentPage * 10 - 9} to ${currentPage * 10 > totalPages * 10 ? totalPages * 10 : currentPage * 10
                        } of ${totalPages * 10} items`}
                </div>
                <Pagination
                    total={totalPages * 10}
                    onChange={handlePageChange}
                    defaultPageSize={10}
                    current={currentPage}
                    size="small"
                />
            </div>

            {/* ── Create / Edit Restaurant Modal ── */}
            <Modal
                title={modalMode === "add" ? "Add Restaurant" : "Edit Restaurant"}
                open={isFormModalOpen}
                onCancel={handleCloseModal}
                footer={null}
                destroyOnClose
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleFormSubmit}
                    className="mt-4"
                >
                    <Form.Item
                        name="name"
                        label="Restaurant Name"
                        rules={[{ required: true, message: "Please enter restaurant name" }]}
                    >
                        <Input placeholder="Enter restaurant name" />
                    </Form.Item>

                    <Form.Item
                        name="email"
                        label="Email"
                        rules={[
                            { required: true, message: "Please enter email" },
                            { type: "email", message: "Please enter a valid email" },
                        ]}
                    >
                        <Input placeholder="Enter email" />
                    </Form.Item>

                    <Form.Item
                        name="mobile_number"
                        label="Mobile Number"
                        rules={[
                            { required: true, message: "Please enter mobile number" },
                            { pattern: /^[0-9]{10}$/, message: "Enter a valid 10-digit mobile number" },
                        ]}
                    >
                        <Input placeholder="Enter mobile number" />
                    </Form.Item>

                    {/* Password only required when creating a new restaurant */}
                    {modalMode === "add" && (
                        <Form.Item
                            name="password"
                            label="Password"
                            rules={[
                                { required: true, message: "Please enter password" },
                                { min: 6, message: "Password must be at least 6 characters" },
                            ]}
                        >
                            <Input.Password placeholder="Enter password" />
                        </Form.Item>
                    )}

                    <Form.Item
                        name="address"
                        label="Address"
                        rules={[{ required: true, message: "Please enter address" }]}
                    >
                        <Input.TextArea placeholder="Enter address" rows={2} />
                    </Form.Item>

                    <Form.Item className="mb-0 flex justify-end">
                        <div className="flex justify-end gap-2">
                            <Button onClick={handleCloseModal}>Cancel</Button>
                            <Button type="primary" htmlType="submit" loading={formLoading}>
                                {modalMode === "add" ? "Create" : "Update"}
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};
export default AllRestroList;